import { Empty } from "antd";

const EmptyData = ({ description, icon }: { description: string, icon?: React.ReactNode }) => {
    return (
        <Empty
            description={description}
            image={icon}
            style={{ margin: "40px 0" }}
        />
    );
};

export default EmptyData;